import { render, staticRenderFns } from "./introduce.vue?vue&type=template&id=3df7a5cb&scoped=true&"
import script from "./introduce.vue?vue&type=script&lang=js&"
export * from "./introduce.vue?vue&type=script&lang=js&"
import style0 from "./introduce.vue?vue&type=style&index=0&id=3df7a5cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df7a5cb",
  null
  
)

export default component.exports